import * as types from './action-types';
import isArray from 'lodash/isArray';

const initialState = {
    processing: false,
    coordinates: [],
    excavationIds: []
};

export default (state = initialState, action) => {
    let newState = state;

    switch (action.type) {
        case types.LOADING:
            newState = { processing: true, excavationIds: action.excavationIds };
            break;
        case types.DATA_LOADED:
            newState = { ...state, processing: false, coordinates: action.coordinates };
            break;
    }

    return newState;
}


// WEBPACK FOOTER //
// ./App/components/modules/chainageChart/reducer.js